import { render, staticRenderFns } from "./customerStatus.vue?vue&type=template&id=d25c0b96&scoped=true&"
import script from "./customerStatus.vue?vue&type=script&lang=js&"
export * from "./customerStatus.vue?vue&type=script&lang=js&"
import style0 from "./customerStatus.vue?vue&type=style&index=0&id=d25c0b96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25c0b96",
  null
  
)

export default component.exports